<script>
	// From Lucide
	import { Mails } from 'lucide-svelte';

	export let iconClass = '';
</script>

<Mails class={iconClass} />
